import React from 'react';
import { MapPin, Check } from 'lucide-react';
import { contactInfo } from '../utils/mockData';

const ServiceAreas = () => {
  return (
    <section className="section-padding">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="section-title">Service Areas in Hampshire</h2>
          <div className="section-title-underline"></div>
          <p className="section-description">
            Providing expert personal training services across Hampshire and surrounding areas
          </p>
        </div>

        <div className="service-areas-content">
          <div className="service-areas-text">
            <h3 className="service-areas-heading">
              <MapPin className="inline-block mr-2 text-lime-green" size={28} />
              Covering All Major Hampshire Locations
            </h3>
            <p className="service-areas-description">
              Based in Hampshire, I provide professional personal training, sports massage therapy, 
              and wellness coaching to clients throughout the county. Whether you're in a major city 
              or a smaller town, I'm here to help you achieve your fitness goals.
            </p>
            <p className="service-areas-description">
              <strong>Online Coaching Available:</strong> Can't meet in person? I also offer comprehensive 
              online personal training programs with the same level of support and customization, accessible 
              from anywhere in the UK.
            </p>
          </div>

          <div className="service-areas-grid">
            {contactInfo.serviceAreas.map((area, index) => (
              <div key={index} className="service-area-card">
                <Check className="service-area-icon" />
                <h4 className="service-area-name">{area}</h4>
                <p className="service-area-label">Hampshire</p>
              </div>
            ))}
          </div>

          <div className="service-areas-cta">
            <h4 className="service-areas-cta-title">Don't see your location?</h4>
            <p className="service-areas-cta-text">
              I'm always expanding my service areas and offer online coaching throughout the UK. 
              Get in touch to discuss how I can help you, wherever you're based.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceAreas;
